import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {MicrophonePermissionStatus} from "../types/MicrophonePermissionStatus";

interface IMicrophoneState {
  permissionStatus: MicrophonePermissionStatus;
}

const initialState: IMicrophoneState = {
  permissionStatus: "notset", // Unchecked
};

export const microphoneSlice = createSlice({
  name: 'microphone',
  initialState: initialState,
  reducers: (create) => ({
    permissionStatusReducer: create.reducer((state, action: PayloadAction<MicrophonePermissionStatus>) => {
      state.permissionStatus = action.payload;
    }),
  }),

  selectors: {
    permissionStatusSelector: (state: IMicrophoneState) => state.permissionStatus,
    isAvailable: (state: IMicrophoneState) => {
      return state.permissionStatus === "granted" || state.permissionStatus === "requestable";
    },
  }
});

export const microphoneReducer = microphoneSlice.reducer;
